var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRollerPaintBrush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.5C5.30964 3.5 4.75 4.05964 4.75 4.75V6.75C4.75 7.44036 5.30964 8 6 8H17C17.6904 8 18.25 7.44036 18.25 6.75V4.75C18.25 4.05964 17.6904 3.5 17 3.5H6ZM19.75 5.10352V4.75C19.75 3.23122 18.5188 2 17 2H6C4.48122 2 3.25 3.23122 3.25 4.75V6.75C3.25 8.26878 4.48122 9.5 6 9.5H17C18.5188 9.5 19.75 8.26878 19.75 6.75C20.0536 6.97805 20.25 7.34105 20.25 7.75V10C20.25 10.6904 19.6904 11.25 19 11.25H14C12.4812 11.25 11.25 12.4812 11.25 14V14.3535C10.0957 14.68 9.25 15.7412 9.25 17V19.25C9.25 20.7688 10.4812 22 12 22C13.5188 22 14.75 20.7688 14.75 19.25V17C14.75 15.7412 13.9043 14.68 12.75 14.3535V14C12.75 13.3096 13.3096 12.75 14 12.75H19C20.5188 12.75 21.75 11.5188 21.75 10V7.75C21.75 6.49122 20.9043 5.42998 19.75 5.10352ZM12 15.75C11.3096 15.75 10.75 16.3096 10.75 17V19.25C10.75 19.9404 11.3096 20.5 12 20.5C12.6904 20.5 13.25 19.9404 13.25 19.25V17C13.25 16.3096 12.6904 15.75 12 15.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollerPaintBrush);
export default __webpack_public_path__ + "static/media/roller-paint-brush.9e958f88dee5a4ee03fc10c3d4b9151f.svg";
export { ForwardRef as ReactComponent };